module.exports = __webpack_public_path__ + "static/img/shouji.61a0f3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/shouji.jpg
// module id = Flue
// module chunks = 1